import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'maskCode'
})
export class MaskCodePipePipe implements PipeTransform {

  transform(value: string): string {
    // ریجکس برای پیدا کردن کد 8 کاراکتری شامل حروف بزرگ و اعداد
    const regex = /\b[A-Z0-9]{8}\b/g;
    // جایگزینی با ستاره‌ها
    return value.replace(regex, '********');
  }

}
